import { apiClient } from './client'

export interface TargetDTO {
  id: number
  name: string
  name_en: string | null
  scope: string
  scope_en: string | null
  status: string
  tags: string[]
  assets_count: number
  endpoints_count: number
  findings_count: number
  last_scan_at: string | null
  extra: Record<string, unknown>
}

export interface TargetCreate {
  name: string
  name_en?: string
  scope: string
  scope_en?: string
  status?: string
  tags?: string[]
}

export const targetsApi = {
  list: (status?: string) =>
    apiClient.get<TargetDTO[]>('/targets', { params: status ? { status_filter: status } : {} }).then((r) => r.data),
  get: (id: number) => apiClient.get<TargetDTO>(`/targets/${id}`).then((r) => r.data),
  create: (body: TargetCreate) => apiClient.post<TargetDTO>('/targets', body).then((r) => r.data),
  update: (id: number, body: Partial<TargetCreate>) =>
    apiClient.patch<TargetDTO>(`/targets/${id}`, body).then((r) => r.data),
  remove: (id: number) => apiClient.delete(`/targets/${id}`).then(() => undefined),
}
